export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8653.555b8e14.jpg";